import { render, staticRenderFns } from "./HistorySubscription.vue?vue&type=template&id=2f8bf600&"
import script from "./HistorySubscription.vue?vue&type=script&lang=js&"
export * from "./HistorySubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports